import { use_component_is_mounted } from './use_component_is_mounted';

export function use_component_is_mounted_50() {
  return use_component_is_mounted(50, () => {});
}
